import axios from "axios";
export const HTTPClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: "9000",
  withCredentials: true,
})
